// src/components/CaseStudyHome.js
import React from 'react';
import { Layout, MainContent, Description, StartButton } from '../styles/CaseStudyHome.styles';
import { Link } from 'react-router-dom';

const CaseStudyHome = ({ teamId }) => {
    return (
        <div>
            <Layout>
                <MainContent>
                    <h2>Case Study Introduction</h2>
                    <Description>
                        Welcome to the Cuban Bike Case Study! In this interactive simulation, you'll make decisions regarding
                        manufacturing, marketing, and R&D expenditures. Your goal is to maximize profits based on these decisions
                        and achieve the highest score possible.
                    </Description>

                    <Description>Ready to start the game?</Description>

                    {/* Update the Link to include teamId */}
                    <Link to={`/${teamId}/task-description`}>
                        <StartButton>View Game Rules</StartButton>
                    </Link>
                </MainContent>
            </Layout>
        </div>
    );
};

export default CaseStudyHome;
